import {Component, Input, OnInit} from '@angular/core';
import {QuizViewModel} from "../../services/models/quizes/QuizViewModel";
import {ModalController} from "@ionic/angular";
import {QuizService} from "../../services/quiz.service";

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss'],
})
export class QuizComponent implements OnInit {
  @Input()activityUid!: string;
  quizData!: QuizViewModel;
  isAnswered: boolean = false;
  isChecked: boolean = false;
  errorMessage!: string;
  isCorrect!: boolean;
  isFinished: boolean = false;
  correctAnswerUid: string = "";
  constructor(
    private modal: ModalController,
    private quizService: QuizService
  ) { }

  ngOnInit() {
    this.quizService.getQuiz(this.activityUid)
      .then(r => {
        this.quizData = r.quiz;
        // console.log(this.quizData);
      }).catch(e => {
        console.log(e);
    })
  }
  selectAnswer(answerId: string) {
    if (this.isChecked) {
      return;
    }
    this.quizData.question.answers.forEach(x => x.isSelected = (x.id == answerId));
    this.isAnswered = true;
  }
  onCheckAnswer_click() {
    if (this.isFinished) {
      return;
    }
    this.isFinished = true;
    const selectedAnswerId = this.quizData.question.answers.filter(x => x.isSelected)[0].id;
    this.quizService.saveQuiz(this.activityUid, selectedAnswerId)
    .then(r => {
      if (r.statusId === 200) {
        this.quizData = r.quiz;
        if (this.quizData.question.answers.find(i => i.isCorrect)) {
          this.isCorrect = true;
          this.quizData.IsCorrect = true;
        } else {
          this.isCorrect = false;
          this.quizData.IsCorrect = false;
          this.correctAnswerUid = this.quizData.question.correctAnswerUid;
        }
      } else {
        this.errorMessage = r.message;
      }
    }).catch(error => {
        console.log(error);
    }).finally(() => { this.isChecked = true; });
  }

  onClose_click() {
    return this.modal.dismiss(this.quizData, "finished");
  }
  onDismiss_click() {
    return this.modal.dismiss(null);
  }
}
